import { useTranslation } from 'react-i18next';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useLanguage() {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();

  const { data: language } = useQuery({
    queryKey: ['selectedLanguage'],
    queryFn: async () => {
      const storedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      await i18n.changeLanguage(storedLanguage);
      return storedLanguage;
    },
  });

  const changeLanguage = useMutation({
    mutationFn: async (newLang: string) => {
      localStorage.setItem('selectedLanguage', newLang);
      await i18n.changeLanguage(newLang);
      return newLang;
    },
    onSuccess: (newLang) => {
      queryClient.setQueryData(['selectedLanguage'], newLang);
    },
  });

  return { language, changeLanguage };
}
